/* oxlint-disable typescript/no-unsafe-assignment -- interfacing with untyped Ember models during migration */
/* oxlint-disable typescript/no-unsafe-member-access -- interfacing with untyped Ember models during migration */
import { Navigate, useParams } from 'react-router';
import { MainLayout } from '../../../components/layouts/main/main-layout';
import { ContentWrapper } from '../../../components/content-wrapper/content-wrapper';
import { OwnerInfoForm } from '../../../components/owner-info-form';
import { useEmberRegistration } from '../../../hooks/use-ember-registration';
import styles from './owner-info.module.css';

export function OwnerInfoRoute(): React.ReactNode {
  const { registration_id: registrationId } = useParams();
  const { registration, isLoading, isError } = useEmberRegistration(registrationId);

  if (isLoading) {
    return null;
  }

  if (isError || !registration) {
    return <Navigate replace to="/404" />;
  }

  const owner = registration.owner;
  const organization = registration.belongsTo('organization').value();

  if (!owner || !organization) {
    return null;
  }

  return (
    <MainLayout>
      <ContentWrapper>
        <div className={styles.container}>
          <OwnerInfoForm
            organization={organization}
            owner={owner}
            registration={registration}
            registrationId={registrationId}
          />
        </div>
      </ContentWrapper>
    </MainLayout>
  );
}
